export var STORE_KEY = 'ecrionStore';
export default STORE_KEY;